import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Form,Input,Radio,Icon,Button,message } from 'antd';
import LoadingCover from 'components/LoadingCover';
import abortAjaxHoc from 'components/abortAjaxHoc';
import {mixObj} from 'utils/tool';
import style from './Verify.module.less';
import classnames from 'classnames';
import {getLabel} from 'components/TipsView/tools';

const FormItem = Form.Item;
const LabelMap = {
    'security_level':{
        label:'Compare strictness',
        notice:{
            dec:'The stricter the standards, the higher the detection rate, and the lower the corresponding pass rate.'
        }
    },
    'fail_when_multiple_faces':{
        label:'Whether to compare multiple faces (this configuration is only required when you choose picture verification, and this configuration can be ignored for other types)',
        notice:{
            dec:'When selecting comparison, when there are multiple faces in the uploaded photo, the largest face in the picture will be taken for subsequent verification; when no comparison is selected, if the above situation occurs, an error code will be returned directly'
        }
    },
    'face_quality_threshold':{
        label:'Face quality threshold in uploaded photos (this configuration is only required when you select image verification, this configuration takes effect for imge, other types can ignore this)',
        notice:{
            dec:'The threshold value of the face image quality score in the "photo to be compared" (the one with the largest face area), the higher the threshold, the higher the requirement for the clarity of the face in the "photo to be compared"'
        }
    },
    'return_faces':{
        label:'Whether to return the face verification result (this configuration is only required when you choose image verification, other types can ignore this configuration)',
        notice:{
            dec:`When "Yes" is selected, the face verification result (including face quality, face quality threshold, face coordinate points and face direction) will be returned if and only when the rawimage method is selected.
            When "No" is selected, the face verification result will not be returned`
        }
    },
    'force_compare':{
        label:'Whether to open the fake face is still compared',
        notice:{
            dec:'When not enabled, if it is judged to be a fake face attack, the result will be returned directly without comparison'
        }

    },
    'multi_oriented_detection':{
        label:'Whether to enable rotation detection',
        notice:{
            dec:'When it is turned on, when the face cannot be detected, it will rotate 90 degrees, 180 degrees, 270 degrees and continue to detect'
        }
    },
    'image_do_liveness':{
        label:'Image verification verification form (this configuration is only required when you choose image verification, other types can ignore this configuration)',
        notice:{
            dec:'After selecting [liveness+comparison], the picture verification scene will additionally return the live verification result'
        }
    }
};

class SDKLivenessForm extends React.Component {

    constructor(props){
        super(props);
        this.id = props.id; //存在id为编辑模式
        this.mode = this.id === undefined ?'create':'edit';
        this.cacheValues = {};
        this.state = {
            isShowMore:false,
            readOnly:false,
            loading:this.mode === 'edit'
        };
    }

    componentDidMount(){
        if(this.mode === 'edit'){
            this.props.abortableAjax('GET','/verify_scene/'+this.id).then(res=>{
                //先设置场景类型
                const readOnly = res.data.state === 'default';
                this.setState({readOnly},()=>{

                    //获取现有表单数据
                    const {getFieldsValue,setFieldsValue} = this.props.form;
                    const values = getFieldsValue();
                    //取values存在的字段
                    const newValues = mixObj(values,res.data);
                    //表单回填
                    setFieldsValue(newValues,()=>{
                        this.setState({loading:false});
                    });

                });
            });
        }
    }

    onSave = ()=>{
        let url = '/verify_scene';
        let type = 'put';
        if(this.id){
            url = '/verify_scene/'+this.id;
            type = 'post';
        }
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                this.setState({loading:true});
                values['face_quality_threshold'] = parseInt(values['face_quality_threshold']);
                this.props.abortableAjax(type,url,values).then(()=>{
                    message.success('Successful operation');
                    this.props.history.push('/pages/verify-scenes');
                }).catch(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    getLabel = (key)=>{
        return getLabel(LabelMap,key);
    }

    onShowMore = ()=>{
        this.setState({isShowMore:!this.state.isShowMore});
    }

    setDisabled(){
        return this.state.readOnly;
    }

    render(){
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: { span: 3 },
            wrapperCol: { span: 14 }
        };
        const moreClass = classnames({
            [style.moreBox]:true,
            [style.show]:this.state.isShowMore
        });
        return (
            <div style={{marginTop:20}}>
                <LoadingCover spinning={this.state.loading}>
                    <Form layout="vertical">
                        <FormItem label="Scenes Name" {...formItemLayout}>
                            {getFieldDecorator('name',{
                                rules:[
                                    {required:true,message:'not nullable'},
                                    {max:20,message:'Cannot be greater than 20 characters'}
                                ]
                            })(
                                <Input placeholder="Cannot be greater than 20 characters" disabled={this.setDisabled('name')}/>
                            )}
                        </FormItem>
                        <FormItem label="Scenes Describe" {...formItemLayout}>
                            {getFieldDecorator('description',{
                                rules:[
                                    {max:50,message:'Cannot be greater than 50 characters'}
                                ]
                            })(
                                <Input placeholder="Cannot be greater than 50 characters" disabled={this.setDisabled('description')}/>
                            )}
                        </FormItem>
                        <div className={style.line}></div>
                        <h1 className={style.title}>verify config</h1>
                        <FormItem colon={false} label={this.getLabel('security_level')} >
                            {getFieldDecorator('security_level',{
                                initialValue:2,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('security_level')}>
                                    <Radio value={1}>loose</Radio>
                                    <Radio value={2}>conventional</Radio>
                                    <Radio value={3}>strict</Radio>
                                    <Radio value={4}>very strict</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>

                        <div className={style.moreButtonBox}>
                            <span className={style.more} onClick={this.onShowMore}>More advanced settings</span>
                            <Icon className={style.moreArrow} type="down" /><Icon className={style.icon} type="info-circle" theme="filled" />
                            <span className={style.moreDec}>Advanced configuration adjustment suggestions are operated under your exclusive business guidance</span>
                        </div>
                        <div className={moreClass}>
                            <FormItem colon={false} label={this.getLabel('fail_when_multiple_faces')} >
                                {getFieldDecorator('fail_when_multiple_faces',{
                                    initialValue:0,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('fail_when_multiple_faces')}>
                                        <Radio value={0}>compare</Radio>
                                        <Radio value={1}>don't compare</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('face_quality_threshold')} >
                                {getFieldDecorator('face_quality_threshold',{
                                    initialValue:'30',
                                    validateFirst:true,
                                    rules:[
                                        {required:true,message:'not nullable'},
                                        {pattern:/^([1-9]\d*|0)$/,message:'Please enter a number from 0-100'},
                                        {validator:(rule, value, callback)=>{
                                            const num = parseInt(value);
                                            if( num<0 || num>100){
                                                callback('Please enter a number from 0-100');
                                            }else{
                                                callback();
                                            }
                                        }}
                                    ]
                                })(
                                    <Input disabled={this.setDisabled('face_quality_threshold')} style={{width:200}}/>
                                )}
                            </FormItem>

                            <FormItem colon={false} label={this.getLabel('return_faces')} >
                                {getFieldDecorator('return_faces',{
                                    initialValue:1,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('return_faces')}>
                                        <Radio value={1}>yes</Radio>
                                        <Radio value={0}>no</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('image_do_liveness')} >
                                {getFieldDecorator('image_do_liveness',{
                                    initialValue:1,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('image_do_liveness')}>
                                        <Radio value={2}>liveness+comparison</Radio>
                                        <Radio value={1}>only comparison</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('force_compare')} >
                                {getFieldDecorator('force_compare',{
                                    initialValue:0,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('force_compare')}>
                                        <Radio value={1}>yes</Radio>
                                        <Radio value={0}>no</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('multi_oriented_detection')} >
                                {getFieldDecorator('multi_oriented_detection',{
                                    initialValue:1,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('multi_oriented_detection')}>
                                        <Radio value={1}>yes</Radio>
                                        <Radio value={0}>no</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                        </div>

                    </Form>
                    <div>
                        {!this.state.readOnly && <Button type="primary" style={{marginRight:24}} onClick={this.onSave} loading={this.state.loading}>Save</Button>}
                        <Link to="/pages/verify-scenes"><Button>Back</Button></Link>
                    </div>

                </LoadingCover>
            </div>
        );

    }
}

export default Form.create()(abortAjaxHoc(withRouter(SDKLivenessForm)));



// WEBPACK FOOTER //
// ./src/pages/Verify/VerifyForm.js